
//var $window = jQuery(window);


//import "./styles.css";

// first import.
import Headroom from "headroom.js";



var headroomoptions = {
    offset: 0,
  tolerance: {
    up: 0,
    down: 0
  },
  classes: {
    initial: "header--fixed",
    pinned: "slideDown",
    unpinned: "slideUp",
    top: "top",
    notTop: "not-top"
  }
};

window.addEventListener('DOMContentLoaded', (event) => {
   var myElement = document.getElementById("site-header");
	// construct an instance of Headroom, passing the element
	var headroom = new Headroom(myElement, headroomoptions);
	// initialise
	headroom.init();

});





(function($) {
	

	
	
/*
	var myElement = document.querySelector("header");
// construct an instance of Headroom, passing the element
var headroom  = new Headroom(myElement);
// initialise
headroom.init();
*/
	
	function page_init(){
		'use strict';
		$(document).foundation();
		
		
		// grab an element

		
		
		$('a[rel="external"]').on("click", function(){
			window.open( $(this).attr('href') );
			return false;
		});
		
		$('.text_content').fitVids();
		
	

		
		
		if($('#feature_slider').length){
			    $('#feature_slider').slick({
			        dots: false,
			        arrows:true,
			        autoplay:true,
			        accessibility:true,
			        fade:true,
			        speed:1200,
			        pauseOnHover:false,
			        waitForAnimate:false,
			        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
					prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>',
					
					responsive: [
					    {
					      breakpoint: 1024,
					      settings: {
					        	dots: false,
							arrows:true,
					      }
					    },
					    
					    {
					      breakpoint: 767,
					      settings: {
					        	dots: true,
								arrows:false,
					      }
					    }
					    // You can unslick at a given breakpoint now by adding:
					    // settings: "unslick"
					    // instead of a settings object
					  ]
					
			    });
		} //feature_slider
		
		
		if($('#top_slider').length){
			    $('#top_slider').slick({
			        dots: true,
			        arrows:false,
			        autoplay:true,
			        accessibility:true,
			        infinite: true,
			        fade:true,
			        speed:1200,
			        pauseOnHover:false,
			        waitForAnimate:false,
			        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
					prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>',

			    });
		} //feature_slider
		
		
		if($('.flex_slideshow').length){
		    $('.flex_slideshow').slick({
		        dots: true,
		        arrows:false,
		        autoplay:false,
		         adaptiveHeight: true,
		        accessibility:true,
		        fade:true,
		        speed:800,
		        pauseOnHover:true,
		        waitForAnimate:false,
		        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
				prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>'
		    });
		    $('.flex_slideshow').on('init', function(event, slick){
				//init? afterChange?
				Plyr.setup('.js-player');
				
			});
		    
		}
		
		
		if($('.flex_carousel').length){
		    $('.flex_carousel').slick({
		        dots: true,
		        arrows:false,
		        slidesToShow: 4,
			slidesToScroll: 4,
			autoplay:true,
			  responsive: [
			    {
			      breakpoint: desktop_breakpoint,
			      settings: {
			        slidesToShow: 4,
			        slidesToScroll: 4,
			        infinite: true,
			        dots: false
			      }
			    },
			    {
			      breakpoint: tablet_breakpoint,
			      settings: {
			        slidesToShow: 3,
			        slidesToScroll: 3
			      }
			    },
			    {
			      breakpoint: small_breakpoint,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1
			      }
			    }
			    // You can unslick at a given breakpoint now by adding:
			    // settings: "unslick"
			    // instead of a settings object
			  ],
		        autoplay:false,
		         adaptiveHeight: true,
		        accessibility:true,
		        fade:true,
		        speed:800,
		        pauseOnHover:true,
		        waitForAnimate:false,
		        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
				prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>'
		    });
		    $('.flex_carousel').on('afterChange', function(event, slick){
				Plyr.setup('.js-player');
			});
		    
		}
		
		
		$.fancybox.defaults.hash = false;
		
		
/*
		
		$('.thumb_block').on("click", '.grid_link', function(e){
			e.preventDefault();
			
		});
*/
		
		
		$('.resource_fancy').fancybox({
			afterShow : function( instance, current ) {
				 $('.text_content').fitVids();
// 				alert('hiii');
			}
		});
		
			
			
	}
		
	$(function() {
		page_init();	
	
	});
	
	
	$(document).on('facetwp-loaded', function() {
	$('.filter_strip').on("click", '#venuemap_reveal', function(e){
			e.preventDefault();
		
			if($('#venuemap').hasClass('hidden')){
				$('#venuemap').removeClass('hidden').show();
				 FWP.autoload();
				$('#venuemap_reveal').removeClass('active');
			}
			else{
				$('#venuemap').addClass('hidden').hide();
				$('#venuemap_reveal').addClass('active');
			}
			
			
			//$('#projectlist').hide();
			
			//$('#projectlist_reveal').removeClass('active');
		});
		
/*
		 if ('object' !== typeof FWP) {
                return;
        }
*/
		
		FWP.hooks.addAction('facetwp_map/marker/click', function(marker) {
   
    var post_id = marker.post_id;
    
	window.history.pushState('obj', 'Venue', '#marker'+post_id);
});
});


	
	
	$('.resource_fancy').fancybox({
	  
	  afterShow : function() { 
		  $('.text_content').fitVids();
		  
		}
	});
	
	
	/*
    $(document).on('facetwp-loaded', function() {
        $('html, body').animate({ scrollTop: 0 }, 500);
     });
     $(document).on('facetwp-loaded', function() {
*/

//https://gist.facetwp.com/?_keywords=map



	
/*
	window.onpopstate = function(event) {
  alert(`location: ${document.location}, state: ${JSON.stringify(event.state)}`);
  
	  if(window.location.hash) {
	    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
	    if(hash=="marker1"){
	        marker.setIcon(iconBasetitle);
	    }
	}

}
	
	var postid = $(this).attr('data-id');
        var markers = FWP_MAP.get_post_markers(postid);
        $.each( markers, function( key, value ) {
            google.maps.event.trigger(value, 'click');  
        });
*/
	
/*
	$( window ).on( 'elementor/frontend/element_ready/global', function() {
			page_init();	
	});
	
	
	$( window ).on( 'elementor/frontend/init', function() {
	    //hook name is 'frontend/element_ready/{widget-name}.{skin} - i dont know how skins work yet, so for now presume it will
	    //always be 'default', so for example 'frontend/element_ready/slick-slider.default'
	    //$scope is a jquery wrapped parent element
	    elementorFrontend.hooks.addAction( 'frontend/element_ready/shortcode.default', function($scope, $){
	        page_init();
	
	    });
	 } );
	
*/
	
})( jQuery );




 